import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SafetyControlSurveysPage } from "src/components/views/erp/safetyControl/SafetyControlSurveysPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/erp/safetyControlSurvey/surveys")({
	staticData: { title: i18n.t("surveys.safety_control"), legacyViewKey: "safetyControlSurveysPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <SafetyControlSurveysPage isActive={isActive} />;
}
